import { render, staticRenderFns } from "./RelatorioSolicitacoesPorProduto.vue?vue&type=template&id=225afcdd"
import script from "./RelatorioSolicitacoesPorProduto.vue?vue&type=script&lang=js"
export * from "./RelatorioSolicitacoesPorProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports